import jwtDecode from "jwt-decode";
import dayjs from "dayjs";

/** 解析 JWT；無法解析時回傳 null */
export function decodeJwtSafely(token) {
  if (!token || typeof token !== "string") return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

/** 依 JWT 的 exp 判斷是否已過期；無 exp 欄位時視為未過期（交由後端驗證） */
export function isTokenExpired(token, nowUnix = dayjs().unix()) {
  const payload = decodeJwtSafely(token);
  if (!payload) return true;
  if (payload.exp == null) return false;
  return nowUnix > payload.exp;
}
